<nav class="navbar navbar-expand-lg navbar-light">
    <div class="container">
        <a class="navbar-brand" (click)="onNavbarBrandClick()" style="cursor: pointer;">
            <img src="assets/img/logo.svg" alt="logo">
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
    
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <!-- Elementos del menú - solo visibles cuando no está autenticado -->
            <ul *ngIf="!isAuthenticated" class="navbar-nav">
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('app-about')">METODOLOGÍA</a></li>
            </ul>

            <ul *ngIf="!isAuthenticated" class="navbar-nav">
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('app-download')">NOSOTROS</a></li>
            </ul>

            <ul *ngIf="!isAuthenticated" class="navbar-nav">
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('book-author')">SOBRE MÍ</a></li>
            </ul>

            <ul *ngIf="!isAuthenticated" class="navbar-nav">
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('saas-feedback')">RESEÑAS</a></li>
            </ul>

            <ul *ngIf="!isAuthenticated" class="navbar-nav">
                <li class="nav-item"><a class="nav-link" (click)="scrollToSection('app-pricing')">PLANES</a></li>
            </ul>



            <ul *ngIf="!isAuthenticated" class="navbar-nav login-button-container">
                <button routerLink="/login" class="btn btn-custom-purple">INICIAR SESIÓN</button>
            </ul>

            <ul (click)="gotoAprendizaje()" *ngIf="isAuthenticated" class="navbar-nav ms-auto d-lg-none" style="border-top: 1px solid #e5e5e5;">
                <li class="nav-item"><span class="nav-link">MENÚ TUDI</span></li>
            </ul>
            <ul (click)="gotoSoporte()" *ngIf="isAuthenticated" class="navbar-nav ms-auto d-lg-none" style="border-top: 1px solid #e5e5e5;">
                <li class="nav-item"><span class="nav-link">SOPORTE</span></li>
            </ul>
            
            <ul *ngIf="isAuthenticated" class="navbar-nav ms-auto d-lg-none logout-button-container" style="border-top: 1px solid #e5e5e5;">
                <li class="nav-item" style="width:100%;display:flex;justify-content:center;align-items:center;">
                    <button class="btn btn-custom-purple" (click)="onLogoutFromProfile()">CERRAR SESIÓN</button>
                </li>
            </ul>
            <!-- Menú para usuario autenticado en computadoras -->
            <ul *ngIf="isAuthenticated" class="navbar-nav ms-auto d-none d-lg-flex">
                <li class="nav-item d-flex align-items-center position-relative justify-content-end">
                    <!-- Icono de perfil con nombre y apellido -->
                    <div class="profile-container">
                        <div class="profile-avatar" (click)="toggleProfileMenu()">
                            <span class="profile-name-display">{{ getUserDisplayName() }}</span>
                        </div>
                        <!-- Menú desplegable del perfil -->
                        <div *ngIf="showProfileMenu" class="profile-dropdown">
                            <div class="profile-dropdown-header">
                                <div class="profile-info">
                                    <div class="profile-name">{{ userName }}</div>
                                    <div class="profile-email">{{ userEmail }}</div>
                                    <div class="profile-plan">{{ userPlan }}</div>
                                </div>
                            </div>
                            <div class="profile-dropdown-divider"></div>
                            <div class="profile-dropdown-menu">
                                <button class="profile-menu-item" (click)="tuEstudio()">
                                    <i class="fas fa-book"></i>
                                    <span>MENÚ TUDI</span>
                                </button>
                                <button class="profile-menu-item" (click)="ayuda()">
                                    <i class="las la-headset"></i>
                                    <span>SOPORTE</span>
                                </button>
                                <button class="profile-menu-item logout-item" (click)="onLogoutFromProfile()">
                                    <i class="fas fa-sign-out-alt"></i>
                                    <span>CERRAR SESIÓN</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>

    <!-- Popup de confirmación para cerrar sesión (fuera del navbar para que funcione en móvil y desktop) -->
    <div *ngIf="showLogoutConfirm" class="logout-popup-backdrop" (click)="cancelLogout()">
        <div class="logout-popup" (click)="$event.stopPropagation()">
            <p>¿Deseas cerrar sesión?</p>
            <div class="popup-buttons">
                <button class="btn btn-danger me-2" (click)="confirmLogout()">Aceptar</button>
                <button class="btn btn-secondary" (click)="cancelLogout()">Cancelar</button>
            </div>
        </div>
    </div>
</nav>